import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import MultiLingualContent from "./multilingualContent";
import React from "react";
import { map } from "leaflet";
import {show} from '../constants/countries.override'

export const translations = {
    english: {
        home: "Home",
        about: "About",
        tboard: "Dashboard",
        sourcenbalance: "Statistics & Balance",
        balance: "Statistics & Balance",
        indicator: "Indicators",
        map: "Energy trade",
        sig: show ? 'Mapview' : 'GIS Portal',
        login: "Login",
        actu: "News",
        contact: "Contact",
        seemore: "See more",
        uselink: "Use link",
        socialnetwork: "Ours networks",
        submit: "Submit",
        year: "Year",
        nodata: "No data available",
        ind1: "Share of RE in electricity production (%)",
        ind2: 'Household access to electricity (%)',
        sankey:'Energy flow',
        menu:'Menu',
        simplbalancedata:'Simplified balance',
        detbalancedata:'Detailed balance',
        combfgazmdata:'Mineral coal and manufactured gas statistics',
        elecqdata:'Electricity and heat statistics',
        enrbiomassedata:'Renewable energies and biomass statistics',
        gaznaturaldata:'Natural gas statistics',
        petroledata:'Oil statistics',
        afrec:'AFREC',
        pageTitle: 'Energy Information System',
        copyrigth: '2025 SustEnergyData',
        term_condition:'Terms & Conditions',
        support: "With technical support of",
        validation:"Confirm",
        name:"Name *",
        email:"Email *",
        subject:"Subject *",
        message:"Message *",
        errortext:'Please enter data',
        keyind: "Keys Indicators",
        sankeydiv: "No data available for the selected year. Please select another year.",
        country: "Country",
        line: "Line",
        bar: "Bar",
        stack: "Stack",
        tiled: "Tiled",
        SaveAsImage: "Save as image",
        structureFinalConsumption: "Structure of final consumption",
        line: "Line",
        bar: "Bar",
        stack: "Stack",
        tiled: "Tiled",
        SaveAsImage: "Save as image",
        primaryEnergyProduction: "Primary energy production",
        error: "An error occurred",
        loading:"Loading ...",
        energyInformationSystem:"Energy Information System",
        energyInformationSystemDesc:"Comprehensive platform for energy data management and analysis",
        regionsCovered:"Regions Covered",
        platformFeatures:"Platform Features",
        quickStats:"Quick Stats",
        availability:"Availability",
        dataAccuracy:"Data Accuracy",
        energyDashboard:"Energy Dashboard",
        energyDashboardSubtitle:"Real-time energy production and consumption analytics",
        vsLastYear: "vs last year",
        primaryEnergy: "Primary Energy",
        finalConsumption: "Final Consumption",
        statistics: "Statistics",
        table: "Table",
        download: "Download",
        oneyear: "Last Year",
        threeyears: "Last 3 Years",
        fiveyears: "Last 5 Years",
        tenyears: "Last 10 Years",
        historicalData: "Historical Data",
        filter: "Filter",
        refresh: "Refresh",
        year: "Year",
        totalProduction: "Total Production ",
        growthRate: "Growth Rate",
        electricityShare: "Electricity Share",
        renewables: "Renewables %",
        latestNews: "Latest News & Updates",
        latestNewsSubtitle: "Stay informed with the latest energy sector developments and insights",
        featured: "Featured",
        noArticlesFound: "No news articles found",
        checkBackLater: "Check back later for updates",
        loadMoreArticles: "Load More Articles",
        readTime: "3 min read",
        readMore: "Read More",
        category: "Energy News",
        contactUs: "Contact Us",
        contactSubtitle: "Have questions about energy data or need support? We're here to help. Reach out to our team for assistance with statistics, reports, or platform features.",
        contactInfo: "Contact Information",
        contactInfoDescription: "Connect with our energy data experts for insights, technical support, or partnership opportunities.",
        socialMedia: "Follow Us",
        socialMediaDescription: "Stay updated with the latest energy news and insights",
        successMessage: "Message Sent Successfully!",
        successMessageDescription: "Thank you for contacting us. Our team will get back to you within 24 hours. For urgent matters, please call our support line.",
        errorMessage: "An error occurred while sending your message. Please try again later.",
        sending: "Sending...",
        allYears: "All Years",
        cookieTitle: "We use cookies",
        cookieDesc: "To improve your experience and analyze usage.",
        decline: "Decline",
        accept: "Accept",
        sig_map_coming_soon: "Coming Soon",
        sig_map_under_development: "Under Development",
        countryPickerHint: 'Display data related to the selected country.',
        actorsTitle: "Actors",
        actorsSubtitle: "Discover the key players in the energy sector.",
        fluxTitle: "Flux",
        trade:"Trade",
        migration:"Migration",
        energy:"Energy",
        code:"Code",
        flag:"Flag",
        short:"Description",
        details:"Informations",
        afrecTitle:"AFREC works to promote the sustainable development of Africa's energy sector",
        odd: "AFREC works to promote the sustainable development of Africa's energy sector in alignment with the Sustainable Development Goals (SDGs), particularly SDG 7 for universal access to clean and affordable energy.",
        defaultSlidetext:"AFREC - Energy for Africa",
        typeFilter:"Type of filter",
        compareView: "Compare View",
        close: "Close",
        french: "French",
        english: "English",
        portugais: "Portuguese",
        swahili: "Swahili",
        appTitle: "NIGER ENERGY INFORMATION SYSTEM",
    },
    french: {
        home: "Accueil",
        about: "A propos",
        tboard: "Tableau de board",
        sourcenbalance: "Statistiques & Bilan",
        balance: "Statistiques & Bilan",
        indicator: "Indicateurs",
        map: "Commerce de l'énergie",
        sig: show ? 'Carte' : 'Portail SIG',
        login: "Connexion",
        actu: "Actualités",
        contact: "Contact",
        seemore: "Voir plus",
        uselink: "Lien utiles",
        socialnetwork: "Nos réseaux",
        submit: "Soumettre",
        year: "Année",
        nodata: "Aucune donnée disponible",
        ind1: "Part des EnR dans la production d'électricité (%)",
        ind2: "Taux d'accès des ménages à l'électricité (%)",
        sankey:'Flux énergétique',
        menu:'Menu',
        simplbalancedata:'Bilan agrégé',
        detbalancedata:'Bilan désagrégé',
        combfgazmdata:'Statistique:Charbon minéral et gaz manufacturé',
        elecqdata:'Statistique:Electricité et chaleur',
        enrbiomassedata:'Statistique:Energies renouvelables et biomasse',
        gaznaturaldata:'Statistique:Gaz naturel',
        petroledata:'Statistique:Pétrole',
        afrec:'AFREC',        
        pageTitle: 'Système d\'Information Énergétique',        
        copyrigth:'2025 SustEnergyData',
        term_condition:'Termes & Conditions Générales d’utilisation',
        support: "Avec le soutien technique de",
        validation:"Valider",
        name:"Nom *",
        email:"Email *",
        subject:"Objet *",
        message:"Message *",
        errortext:'Veuillez saisir une donnée',
        keyind: "Indicateurs clés",
        sankeydiv: "Aucune donnée disponible pour l'année sélectionnée. Veuillez sélectionner une autre année.",
        country: "Pays",
        line: "Ligne",
        bar: "Bar",
        stack: "Empilé",
        tiled: "Tuilé",
        SaveAsImage: "Enregistrer sous forme d'image",
        structureFinalConsumption: "Structure de la consommation finale",
        primaryEnergyProduction: "Production d'énergie primaire",
        error: "Une erreur est survenue",
        loading:"Chargement ...",
        energyInformationSystem:"Système d'information énergétique",
        energyInformationSystemDesc:"Plateforme complète pour la gestion et l'analyse des données énergétiques",
        regionsCovered:"Régions couvertes",
        platformFeatures:"Fonctionnalités de la plateforme",
        quickStats:"Statistiques rapides",
        availability:"Disponibilité",
        dataAccuracy:"Précision des données",
        energyDashboard:"Tableau de bord énergétique",
        energyDashboardSubtitle:"Analyse en temps réel de la production et de la consommation d'énergie",
        vsLastYear: "vs l'année dernière",
        primaryEnergy: "Énergie primaire",
        finalConsumption: "Consommation finale",
        statistics: "Statistiques",
        table: "Tableau",
        download: "Télécharger",
        oneyear: "L'année dernière",
        threeyears: "Les 3 dernières années",
        fiveyears: "Les 5 dernières années",
        tenyears: "Les 10 dernières années",
        historicalData: "Données historiques",
        filter: "Filtrer",
        refresh: "Rafraîchir",
        year: "Année",
        totalProduction: "Production totale",
        growthRate: "Taux de croissance",
        electricityShare: "Part de l'électricité",
        renewables: "% d'énergies renouvelables",
        latestNews: "Dernières nouvelles et mises à jour",
        latestNewsSubtitle: "Restez informé des derniers développements et insights du secteur de l'énergie",
        featured: "En vedette",
        noArticlesFound: "Aucun article d'actualité trouvé",
        checkBackLater: "Revenez plus tard pour les mises à jour",
        loadMoreArticles: "Charger plus d'articles",
        readTime: "3 min de lecture",
        readMore: "Lire la suite",
        category: "Actualités énergétiques",
        contactUs: "Contactez-nous",
        contactSubtitle: "Vous avez des questions sur les données énergétiques ou avez besoin d'aide ? Nous sommes là pour vous aider. Contactez notre équipe pour obtenir de l'aide concernant les statistiques, les rapports ou les fonctionnalités de la plateforme.",
        contactInfo: "Informations de contact",
        contactInfoDescription: "Contactez nos experts en données énergétiques pour des informations, un support technique ou des opportunités de partenariat.",
        socialMedia: "Suivez-nous",
        socialMediaDescription: "Restez informé des derniers développements et insights du secteur de l'énergie",
        successMessage: "Message envoyé avec succès !",
        successMessageDescription: "Merci de nous avoir contactés. Notre équipe vous répondra dans les 24 heures. Pour les questions urgentes, veuillez appeler notre ligne d'assistance.",
        sending: "Envoi en cours...",
        allYears: "Toutes les années",
        cookieTitle: "Nous utilisons des cookies",
        cookieDesc: "Pour améliorer votre expérience et analyser l'utilisation.",
        decline: "Refuser",
        accept: "Accepter",
        sig_map_coming_soon: "Bientôt disponible",
        sig_map_under_development: "En cours de développement",
        countryPickerHint: "Les données affichées sont liées au pays sélectionné.",
        actorsTitle: "Acteurs",
        actorsSubtitle: "Découvrez les acteurs clés du secteur de l'énergie.",
        fluxTitle: "Flux",
        tradeTitle: "Commerce",
        migrationTitle: "Migration",
        energyTitle: "Énergie",
        code:"Code",
        flag:"Drapeau",
        short:"Description",
        details:"Informations",
        afrecTitle: "L’AFREC œuvre pour promouvoir le développement durable du secteur énergétique africain",
        odd:"AFREC travaille pour promouvoir le développement durable du secteur énergétique africain en alignement avec les Objectifs de Développement Durable (ODD), particulièrement l'ODD 7 pour un accès universel à une énergie propre et abordable.",
        defaultSlidetext:"AFREC - Énergie pour l'Afrique",
        typeFilter:"Type de filtre",
        compareView: "Vue de comparaison",
        close: "Fermer",
        french: "Français",
        english: "Anglais",
        portugais: "Portugais",
        swahili: "Swahili",
        appTitle: "SYSTÈME D'INFORMATION ÉNERGÉTIQUE DU NIGER",
    },
    portuguais: {
        home: "home",
        about: "Uma proposta",
        tboard: "Quadro de bordo",
        sourcenbalance: "Fonte e Bilan",
        balance: "Fonte e Bilan",
        indicator: "Indicadores",
        map: "Commercio de energia",
        sig: show ? 'Mapa' : 'Portal SIG',
        login: "Ligação",
        actu: "Notícias",
        contact: "Contacto",
        seemore: "Ver mais",
        uselink: "Ligações úteis",
        socialnetwork: "As nossas redes",
        submit: "Enviar",
        year: "Ano",
        nodata: "Não existem dados disponíveis",
        ind1: "Quota de energias renováveis na produção de eletricidade (%)",
        ind2: "Acesso do agregado familiar à eletricidade (%)",
        sankey:'Fluxo de energia',
        menu:'Menu',
        simplbalancedata:'Balanço agregado',
        detbalancedata:'Balanço desagregado',
        combfgazmdata:'Estatísticas:Carvão mineral e gás manufaturado',
        elecqdata:'Estatísticas:Eletricidade e calor',
        enrbiomassedata:'Estatísticas:Energias renováveis e biomassa',
        gaznaturaldata:'Estatísticas:Gás natural',
        petroledata:'Estatísticas:Óleo',
        afrec:'AFREC',
        pageTitle: 'Sistema de Informação Energética',
        copyrigth:'2025 SustEnergyData',
        term_condition:'Termos e condições',
        support: "Com o apoio técnico de",
        validation:"Confirmar",
        name:"Nome *",
        email:"Email *",
        subject:"Objeto *",
        message:"Mensagem *",
        errortext:'Introduzir dados',
        keyind: "Keys Indicators",
        sankeydiv: "Não existem dados disponíveis para o ano selecionado. Por favor, selecione outro ano.",
        country: "País",
        line: "Linha",
        bar: "Barra",
        stack: "Empilhado",
        tiled: "Tile",
        SaveAsImage: "Salvar como imagem",
        structureFinalConsumption: "Estrutura do consumo final",
        primaryEnergyProduction: "Produção de energia primária",
        error: "Ocorreu um erro",
        loading:"Carregando ...",
        energyInformationSystem:"Sistema de Informação Energética",
        energyInformationSystemDesc:"Plataforma abrangente para gestão e análise de dados energéticos",
        regionsCovered:"Regiões Cobertas",
        platformFeatures:"Funcionalidades da Plataforma",
        quickStats:"Estatísticas Rápidas",
        availability:"Disponibilidade",
        dataAccuracy:"Precisão dos Dados",
        energyDashboard:"Painel de Energia",
        energyDashboardSubtitle:"Análise em tempo real da produção e consumo de energia",
        vsLastYear: "vs ano passado",
        primaryEnergy: "Energia Primária",
        finalConsumption: "Consumo Final",
        statistics: "Estatísticas",
        table: "Tabela",
        download: "Baixar",
        oneyear: "Ano Passado",
        threeyears: "Últimos 3 Anos",
        fiveyears: "Últimos 5 Anos",
        tenyears: "Últimos 10 Anos",
        historicalData: "Dados Históricos",
        filter: "Filtrar",
        refresh: "Atualizar",
        year: "Ano",
        totalProduction: "Produção Total",
        growthRate: "Taxa de Crescimento",
        electricityShare: "Quota de Eletricidade",
        renewables: "Renováveis %",
        latestNews: "Últimas Notícias e Atualizações",
        latestNewsSubtitle: "Mantenha-se informado sobre os últimos desenvolvimentos e insights do setor de energia",
        featured: "Destaque",
        noArticlesFound: "Nenhum artigo de notícias encontrado",
        checkBackLater: "Verifique novamente mais tarde para atualizações",
        loadMoreArticles: "Carregar mais artigos",
        readTime: "3 min de leitura",
        readMore: "Leia mais",
        category: "Notícias de Energia",
        contactUs: "Contate-Nos",
        contactSubtitle: "Tem dúvidas sobre dados de energia ou precisa de suporte? Estamos aqui para ajudar. Entre em contato com nossa equipe para obter assistência com estatísticas, relatórios ou recursos da plataforma.",
        contactInfo: "Informações de Contato",
        contactInfoDescription: "Conecte-se com nossos especialistas em dados de energia para obter insights, suporte técnico ou oportunidades de parceria.",
        socialMedia: "Siga-nos",
        socialMediaDescription: "Mantenha-se informado sobre os últimos desenvolvimentos e insights do setor de energia",
        successMessage: "Mensagem enviada com sucesso!",
        successMessageDescription: "Obrigado por entrar em contato conosco. Nossa equipe retornará dentro de 24 horas. Para assuntos urgentes, ligue para nossa linha de suporte.",
        sending: "Enviando...",
        allYears: "Todos os anos",
        cookieTitle: "Utilizamos cookies",
        cookieDesc: "Para melhorar a sua experiência e analisar a utilização.",
        decline: "Rejeitar",
        accept: "Aceitar",
        sig_map_coming_soon: "Brevemente",
        sig_map_under_development: "Em desenvolvimento",
        countryPickerHint: "Os dados apresentados estão associados ao país selecionado.",
        actorsTitle: "Atores",
        actorsSubtitle: "Descubra os principais intervenientes no setor da energia.",
        fluxTitle: "Fluxo",
        tradeTitle: "Comércio",
        migrationTitle: "Migração",
        energyTitle: "Energia",
        code: "Código",
        flag: "Bandeira",
        short: "Descrição",
        details: "Informações",
        afrecTitle: "A AFREC trabalha para promover o desenvolvimento sustentável do setor energético africano",
        odd: "AFREC trabalha para promover o desenvolvimento sustentável do setor energético africano em alinhamento com os Objetivos de Desenvolvimento Sustentável (ODS), especialmente o ODS 7, para garantir acesso universal a energia limpa e acessível.",
        defaultSlidetext:"AFREC - Energia para a África",
        typeFilter:"Tipo de filtro",
        compareView: "Vista de Comparación",
        close: "Fechar",
        french: "Francês",
        english: "Inglês",
        portugais: "Português",
        swahili: "Suaíli",
        appTitle: "SISTEMA DE INFORMAÇÃO ENERGÉTICA DO NÍGER",
    },
    swahili: {
        home: "Nyumbani",
        about: "Kuhusu",
        tboard: "Dashibodi",
        sourcenbalance: "Takwimu & Mizani",
        balance: "Takwimu & Mizani",
        indicator: "Viashiria", 
        map: "Mtiririko wa biashara",
        sig: show ? 'Ramani' : 'SIG Portal',
        login: "Ingia",
        actu: "Habari",
        contact: "Wasiliana",
        seemore: "Tazama zaidi",
        uselink: "Viungo muhimu",
        socialnetwork: "Mitandao yetu",
        submit: "Wasilisha",
        year: "Mwaka",
        nodata: "Hakuna data inayopatikana",
        ind1: "Sehemu ya RE katika uzalishaji wa umeme (%)",
        ind2: "Upatikanaji wa kaya kwa umeme (%)",
        sankey:'Mtiririko wa nishati',
        menu:'Menyu',
        simplbalancedata:'Mizani rahisi',
        detbalancedata:'Mizani ya kina',
        combfgazmdata:'Takwimu za makaa ya mawe na gesi iliyotengenezwa',
        elecqdata:'Takwimu za umeme na joto',
        enrbiomassedata:'Takwimu za nishati mbadala na bio-masi',
        gaznaturaldata:'Takwimu za gesi asilia',    
        petroledata:'Takwimu za mafuta',
        afrec:'AFREC',
        pageTitle: 'Mfumo wa Taarifa za Nishati',
        copyrigth: '2025 SustEnergyData',
        term_condition:'Masharti & Masharti',
        support: "Kwa msaada wa kiufundi wa",
        validation:"Thibitisha",
        name:"Jina *",  
        email:"Barua pepe *",
        subject:"Somo *",
        message:"Ujumbe *",
        errortext:'Tafadhali ingiza data',
        keyind: "Viashiria Muhimu",
        sankeydiv: "Hakuna data inayopatikana kwa mwaka ulioteuliwa. Tafadhali chagua mwaka mwingine.",
        country: "Nchi",
        line: "Mstari",
        bar: "Bar",
        stack: "Stack",
        tiled: "Tile",
        SaveAsImage: "Hifadhi kama picha",
        structureFinalConsumption: "Muundo wa matumizi ya mwisho",
        primaryEnergyProduction: "Uzalishaji wa nishati ya msingi",
        error: "Tatizo limetokea",
        loading:"Inapakia ...",
        energyInformationSystem:"Energy Information System",
        energyInformationSystemDesc:"Comprehensive platform for energy data management and analysis",
        regionsCovered:"Maeneo Yaliyofunikwa",
        platformFeatures:"Vipengele vya Jukwaa",
        quickStats:"Takwimu za Haraka",
        availability:"Upatikanaji",
        dataAccuracy:"Usahihi wa Takwimu",
        energyDashboard:"Dashibodi ya Nishati",
        energyDashboardSubtitle:"Uchambuzi wa wakati halisi wa uzalishaji na matumizi ya nishati",
        vsLastYear: "ikilinganishwa na mwaka jana",
        primaryEnergy: "Nishati ya Msingi",
        finalConsumption: "Matumizi ya Mwisho",
        statistics: "Takwimu",
        table: "Jedwali",
        download: "Pakua",
        oneyear: "Mwaka Uliopita",
        threeyears: "Miaka 3 iliyopita",
        fiveyears: "Miaka 5 iliyopita",
        tenyears: "Miaka 10 iliyopita",
        historicalData: "Takwimu za kihistoria",
        filter: "Chuja",
        refresh: "Futa upya",
        year: "Mwaka",
        totalProduction: "Jumla ya Uzalishaji",
        growthRate: "Kiwango cha Ukuaji",
        electricityShare: "Sehemu ya Umeme",
        renewables: "Mbadala %",
        latestNews: "Habari na Sasisho za Hivi Punde",
        latestNewsSubtitle: "Kuwa na habari kuhusu maendeleo na maarifa ya hivi punde katika sekta ya nishati",
        featured: "Iliyotajwa",
        noArticlesFound: "Hakuna makala za habari zilizopatikana",
        checkBackLater: "Angalia tena baadaye kwa masasisho",
        loadMoreArticles: "Pakia Makala Zaidi",
        readTime: "Soma kwa dakika 3",
        readMore: "Soma Zaidi",
        category: "Habari za Nishati",
        contactUs: "Wasiliana Nasi",
        contactSubtitle: "Je, una maswali kuhusu data ya nishati au unahitaji msaada? Tuko hapa kusaidia. Wasiliana na timu yetu kwa msaada kuhusu takwimu, ripoti, au vipengele vya jukwaa.",
        contactInfo: "Taarifa za Mawasiliano",
        contactInfoDescription: "Ungana na wataalamu wetu wa data ya nishati kwa maarifa, msaada wa kiufundi, au fursa za ushirikiano.",
        socialMedia: "Tufuate",
        socialMediaDescription: "Kuwa na habari kuhusu maendeleo na maarifa ya hivi punde katika sekta ya nishati",
        successMessage: "Ujumbe Umetumwa Kwa Mafanikio!",
        successMessageDescription: "Asante kwa kuwasiliana nasi. Timu yetu itakujibu ndani ya masaa 24. Kwa masuala ya dharura, tafadhali piga simu kwenye laini yetu ya msaada.",
        sending: "Inatuma...",
        allYears: "Mwaka wote",
        cookieTitle: "Tunatumia vidakuzi",
        cookieDesc: "Ili kuboresha uzoefu wako na kuchambua matumizi.",
        decline: "Kataa",
        accept: "Kubali",
        sig_map_coming_soon: "Haitakaa muda mrefu",
        sig_map_under_development: "Inaendelea Kuendelezwa",
        countryPickerHint: "Data inayoonyeshwa inahusishwa na nchi iliyochaguliwa.",
        actorsTitle: "Wachezaji",
        actorsSubtitle: "Gundua wachezaji muhimu katika sekta ya nishati.",
        fluxTitle: "Mtiririko",
        tradeTitle: "Biashara",
        migrationTitle: "Uhamiaji",
        energyTitle: "Nishati",
        code: "Msimbo",
        flag: "Bendera",
        short: "Maelezo",
        afrecTitle: "AFREC inafanya kazi kukuza maendeleo endelevu ya sekta ya nishati barani Afrika",
        odd: "AFREC inafanya kazi kukuza maendeleo endelevu ya sekta ya nishati barani Afrika kwa kulingana na Malengo ya Maendeleo Endelevu (SDGs), hasa Lengo la 7 (SDG 7), ili kuhakikisha upatikanaji wa nishati safi na nafuu kwa wote.",
        defaultSlidetext: "AFREC - Nishati kwa Afrika",
        typeFilter: "Aina ya kichujio",
        compareView: "Muonekano wa Kulinganisha",
        close: "Funga",
        french: "Kifaransa",
        english: "Kiingereza",
        portugais: "Kireno",
        swahili: "Kiswahili",
        appTitle: "SISTEMA DE INFORMAÇÃO ENERGÉTICA DO NÍGER",
    }
};